import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FlareFileTextEditorFeatureUnsupportedDialogComponent } from './flare-file-text-editor-feature-unsupported-dialog.component';

@NgModule({
  declarations: [
    FlareFileTextEditorFeatureUnsupportedDialogComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule
  ],
  exports: [
    FlareFileTextEditorFeatureUnsupportedDialogComponent
  ]
})
export class FlareFileTextEditorFeatureUnsupportedDialogModule { }
